import gql from 'graphql-tag'

import { pageInfoFragment } from '~/gql/fragments'

import reviewFragment from '../fragments/review-fragment'

const productReviewsQuery = gql`
  query productReviews($slug: String!, $page: Int, $limit: Int) {
    vendor {
      id
      product(slug: $slug) {
        id
        defaultPhoto
        name
        presentation
        pricing {
          oldPrice
          price
          ribbonLabel
          isTaxExempt
        }
        reviewStats {
          rating
          numOfReviews
          oneStar
          twoStars
          threeStars
          fourStars
          fiveStars
        }
        reviews(page: $page, limit: $limit) {
          items {
            ...review
            reviewer {
              id
              fullName
            }
          }
          pageInfo {
            ...pageInfo
          }
        }
      }
    }
  }
  ${pageInfoFragment}
  ${reviewFragment}
`

export default productReviewsQuery
